import * as ko from 'knockout'
import template from './standard.top.panel.tpl.html'
import { Params, StandardTopPanel } from './StandardTopPanel'

if (!ko.components.isRegistered('standard-top-panel')) {
  ko.components.register('standard-top-panel', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new StandardTopPanel(params)
        return viewModel
      },
    },
    template,
  })
}
